"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ERROR_HANDLER = function (err) {
    //do nothing
};
